import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewSettingsUrlsComponent } from './view-settings-urls.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { SidenavHeaderModule } from 'src/app/components/sidenav-header/sidenav-header.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    ViewSettingsUrlsComponent
  ],
  imports: [
    CommonModule,
    SidenavHeaderModule,
    SharedModule,
    IconsModule,
    ClipboardModule,
  ],
  exports: [
    ViewSettingsUrlsComponent
  ],
})
export class ViewSettingsUrlsModule { }
